import { trackEvent } from './track-event'

type Action =
  | 'offer experience'
  | 'show me more'
  | 'register for free'
  | 'get in contact'
  | 'contact directly'
  | 'email contact'
  | 'browse the magazine'
  | (string & {})

type Type = 'guide' | 'erlebnisse-anbieten' | (string & {})

type TrackCtaButtonPayload = {
  type: Type
}

export function trackCtaButton(action: Action, payload?: TrackCtaButtonPayload) {
  trackEvent({
    event: 'click_cta_button',
    event_name: 'user_interaction',
    action: `click - ${action}`,
    type: payload?.type,
  })
}
